module.exports = __webpack_public_path__ + "static/img/img_o.c7958ff0.png";